module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//red_3.png?v=48d242e3";